// extracted by mini-css-extract-plugin
export var dropdownIcon = "_pi-6";
export var imgContainer = "_pi-3";
export var menuIcon = "_pi-5";
export var pillWrapper = "_pi-2";
export var pillsContainer = "_pi-1";
export var subscriptionCard = "_pi-0";
export var subscriptionLogo = "_pi-4";